export enum DropdownMultiSize {
    SMALL = 'small',
    DEFAULT = 'default'
  }